export const browserSupportsWebAuthnAutofill = (): Promise<boolean> =>
  !window.PublicKeyCredential?.isConditionalMediationAvailable
    ? new Promise(resolve => resolve(false))
    : window.PublicKeyCredential.isConditionalMediationAvailable()
